var a = /* @__PURE__ */ ((r) => (r.DARK = "dark", r.LIGHT = "light", r))(a || {}), R = /* @__PURE__ */ ((r) => (r.SOLID = "solid", r.REGULAR = "regular", r.BRANDS = "brands", r))(R || {});
export {
  R as IconStyle,
  a as Shade
};
//# sourceMappingURL=enums.js.map
